<!--
 * @Author: FengXiao
 * @Date: 2026-05-18 00:00:00
 * @LastEditors: FengXiao
 * @LastEditTime: 2026-05-18 00:00:00
-->
<template>
  <div class="event-register-page page-container">
    <!-- 顶部导航 -->
    <div class="register-header content">
      <div class="header-title">活动报名</div>
    </div>

    <div class="register-content content">
      <div class="register-layout">
        <!-- 左侧：活动信息 -->
        <div class="left-column">
          <!-- 活动卡片 -->
          <section class="event-card">
            <div class="event-cover">
              <img :src="eventInfo.cover_url" :alt="eventInfo.title">
            </div>
            <div class="event-info">
              <div class="event-title">{{ eventInfo.title }}</div>
              <div class="event-meta">
                <div class="meta-item" v-if="eventInfo.start_time">
                  <i class="iconfont iconshijian meta-icon"></i>
                  <span>{{ formatEventTime() }}</span>
                </div>
                <div class="meta-item" v-if="eventInfo.event_city || eventInfo.event_address">
                  <i class="iconfont iconweizhi meta-icon"></i>
                  <span>{{ eventInfo.event_city }} · {{ eventInfo.event_address }}</span>
                </div>
              </div>
              
              <!-- 主办方信息 -->
              <div class="organizer-info" v-if="eventInfo.organization">
                <div class="organizer-card">
                  <img v-if="eventInfo.organization.avatar_url" :src="eventInfo.organization.avatar_url" class="organizer-logo">
                  <div class="organizer-detail">
                    <div class="organizer-name-row">
                      <span class="organizer-name">{{ eventInfo.organization.name }}</span>
                      <span class="certified-badge" v-if="eventInfo.organization.certify_status == 1">
                        <i class="iconfont iconrenzheng"></i>
                        已认证
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- 票品信息 -->
          <section class="ticket-section">
            <div class="section-title">选择票品</div>
            <div class="ticket-card selected">
              <div class="ticket-left">
                <div class="ticket-name">免费票</div>
                <div class="ticket-price">¥0</div>
              </div>
              <div class="ticket-right">
                <i class="iconfont icongouxuan selected-icon">✓</i>
              </div>
            </div>
          </section>
        </div>

        <!-- 右侧：报名表单 -->
        <div class="right-column">
          <!-- 调试信息 -->
          <div v-if="formList.length === 0" style="padding: 20px; text-align: center; color: #999;">
            正在加载表单数据...
          </div>
          
          <section class="form-section" v-if="formList.length > 0">
            <div class="section-title">报名信息</div>
            <div class="form-content">
              <div v-for="(form, index) in formList" :key="index" class="form-item">
                <label class="form-label" :class="{ 'required': form.need_status }">
                  {{ form.name }}
                </label>
                
                <!-- 文本输入框 (type: 0) -->
                <input
                  v-if="form.type === 0"
                  v-model="formData[form.id]"
                  type="text"
                  class="form-input"
                  :placeholder="`请输入${form.name}`"
                />

                <!-- 数字/多行文本输入框 (type: 1) -->
                <textarea
                  v-else-if="form.type === 1"
                  v-model="formData[form.id]"
                  class="form-textarea"
                  rows="3"
                  :placeholder="`请输入${form.name}`"
                ></textarea>

                <!-- 邮箱输入 (type: 2) -->
                <input
                  v-else-if="form.type === 2"
                  v-model="formData[form.id]"
                  type="email"
                  class="form-input"
                  placeholder="请输入邮箱"
                />

                <!-- 手机号输入 (type: 3) -->
                <input
                  v-else-if="form.type === 3"
                  v-model="formData[form.id]"
                  type="tel"
                  class="form-input"
                  placeholder="请输入手机号"
                />
              </div>
            </div>

            <!-- 表单说明 -->
            <div class="form-tips" v-if="formTips">
              {{ formTips }}
            </div>

            <!-- 审核提示 -->
            <div class="check-tips" v-if="needCheck">
              <i class="iconfont icontishi check-icon"></i>
              <span>报名信息需要经过主办方审核</span>
            </div>
          </section>

          <!-- 底部操作按钮 -->
          <div class="bottom-action">
            <button class="submit-btn" @click="onSubmit" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '下一步' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import requestApi from '@/service';
import { MessageBox } from 'element-ui';

export default {
  name: 'EventRegister',
  data() {
    return {
      eventId: '', // 活动ID
      eventInfo: {}, // 活动信息
      formList: [], // 表单列表
      formData: {}, // 表单数据
      formTips: '', // 表单说明
      needCheck: false, // 是否需要审核
      isSubmitting: false, // 是否正在提交
    };
  },
  computed: {
    ...mapState(['baseUrl', 'user_token']),
  },
  created() {
    console.log('=== EventRegister 组件创建 ===');
    this.eventId = this.$route.query.id;
    console.log('从路由获取的活动ID:', this.eventId);
    this.getEventForm();
  },
  methods: {
    // 获取活动表单信息
    getEventForm() {
      const token = localStorage.getItem('token');
      console.log('=== 开始获取活动表单信息 ===');
      console.log('活动ID:', this.eventId);
      console.log('Token:', token ? '已登录' : '未登录');
      
      if (!token) {
        console.warn('用户未登录，跳转到上一页');
        this.$message.warning('请先登录');
        setTimeout(() => {
          this.$router.back();
        }, 1500);
        return;
      }

      console.log('正在调用接口: /v3/api/h5/event/form/');
      requestApi('/v3/api/h5/event/form/', {
        id: this.eventId,
      }, 'GET', {
        authorization: token,
      }).then(res => {
        console.log('=== 获取活动表单成功 ===');
        console.log('表单数据:', res);
        
        if (res) {
          this.eventInfo = {
            id: res.event_id,
            title: res.event_title,
            cover_url: '', // 需要从活动详情接口获取
            event_city: '',
            event_address: '',
            organization: null,
          };
          this.formList = res.form_list || [];
          this.formTips = res.form_tips || '';
          
          console.log('初始化表单数据...');
          // 初始化表单数据 - 使用 $set 确保响应式
          this.formList.forEach(form => {
            this.$set(this.formData, form.id, '');
          });

          // 获取活动详情以补充信息
          this.getEventDetail();
        }
      }).catch(err => {
        console.error('获取活动表单失败:', err);
        this.$message.error('网络错误，请重试');
      });
    },

    // 获取活动详情
    getEventDetail() {
      console.log('=== 开始获取活动详情 ===');
      const token = localStorage.getItem('token');
      requestApi('/v3/api/h5/event/detail/', {
        id: this.eventId,
      }, 'GET', {
        authorization: token,
      }).then(res => {
        console.log('=== 活动详情接口返回 ===');
        console.log('响应数据:', res);
        
        if (res && res.event_item) {
          const eventItem = res.event_item;
          console.log('活动详情数据:', eventItem);
          
          this.eventInfo.cover_url = eventItem.cover_url;
          this.eventInfo.event_city = eventItem.event_city;
          this.eventInfo.event_address = eventItem.event_address;
          this.eventInfo.start_time = eventItem.start_time;
          this.eventInfo.end_time = eventItem.end_time;
          this.eventInfo.organization = eventItem.organization;
          // 设置是否需要审核
          this.needCheck = eventItem.check === 1;
          
          console.log('更新后的 eventInfo:', this.eventInfo);
          console.log('是否需要审核:', this.needCheck);
        }
      }).catch(err => {
        console.error('=== 获取活动详情失败 ===');
        console.error('错误信息:', err);
      });
    },

    // 格式化活动时间
    formatEventTime() {
      if (!this.eventInfo.start_time || !this.eventInfo.end_time) return '';
      
      const isSameDay = this.checkSameDay(this.eventInfo.start_time, this.eventInfo.end_time);
      
      if (isSameDay) {
        // 同一天：显示 05-20 周三 14:00 - 15:00
        return `${this.formatDateTimeDisplay(this.eventInfo.start_time)} - ${this.formatTimeOnly(this.eventInfo.end_time)}`;
      } else {
        // 不同天：显示 05-20 周三 14:00 至 05-21 周四 15:00
        return `${this.formatDateTimeDisplay(this.eventInfo.start_time)} 至 ${this.formatDateTimeDisplay(this.eventInfo.end_time)}`;
      }
    },

    // 判断两个日期是否为同一天
    checkSameDay(dateStr1, dateStr2) {
      if (!dateStr1 || !dateStr2) return false;
      const d1 = new Date(dateStr1.replace(/-/g, '/'));
      const d2 = new Date(dateStr2.replace(/-/g, '/'));
      return d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();
    },

    // 格式化完整日期时间: 05-20 周三 14:00
    formatDateTimeDisplay(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr.replace(/-/g, '/'));
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const weekDay = weekDays[date.getDay()];
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${month}-${day} ${weekDay} ${hours}:${minutes}`;
    },

    // 仅格式化时间: 14:00
    formatTimeOnly(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr.replace(/-/g, '/'));
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },

    // 提交表单
    onSubmit() {
      console.log('=== 开始提交表单 ===');
      console.log('当前表单数据:', this.formData);
      
      // 验证必填项
      for (let form of this.formList) {
        if (form.need_status === true) {
          const value = this.formData[form.id];
          if (!value) {
            console.warn(`必填项未填写: ${form.name}`);
            this.$message.error(`请填写${form.name}`);
            return;
          }
        }
      }

      // 构造 event_form 数组,格式:[{"id": 1, "name": "姓名", "value": "张三"}]
      const eventFormArray = this.formList.map(form => ({
        id: form.id,
        name: form.name,
        value: this.formData[form.id] || '',
      }));

      // 转换为 JSON 字符串
      const eventFormStr = JSON.stringify(eventFormArray);
      console.log('提交的 event_form:', eventFormStr);

      // 构造提交数据
      const submitData = {
        id: this.eventId,
        event_form: eventFormStr,
      };
      console.log('完整提交数据:', submitData);

      const token = localStorage.getItem('token');
      this.isSubmitting = true;
      
      console.log('正在调用报名接口...');
      requestApi('/v3/api/h5/event/register/', submitData, 'POST', {
        authorization: token,
      }, {
        printMsg: false, // 禁用全局错误提示，由组件自己处理
      }).then(res => {
        this.isSubmitting = false;
        console.log('=== 报名接口返回 ===');
        console.log('响应数据:', res);
        console.log('res.order_num:', res?.order_num);
        
        // 简化 order_num 的获取逻辑，axios 拦截器已处理数据结构
        const orderNum = res?.order_num;
        
        if (orderNum) {
          console.log('报名成功,订单号:', orderNum);
          // 显示报名成功提示
          MessageBox.alert('报名成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: () => {
              // 点击确定后跳转到活动列表页
              this.$router.push({
                path: '/event',
              });
            },
          });
        } else {
          // 接口返回但没有 order_num，也视为失败
          console.warn('未找到 order_num，完整返回数据:', res);
          this.$message.error(res?.error_msg || '报名失败，请重试');
        }
      }).catch(err => {
        this.isSubmitting = false;
        console.error('=== 报名接口调用失败 ===');
        console.error('错误信息:', err);
        this.$message.error(err.error_msg || '网络错误,请重试');
      });
    },

    // 返回
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.event-register-page {
  padding-top: 20px;
  
  .register-header {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid $C11;
    margin-bottom: 30px;
    
    .back-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: $C9;
      font-size: 14px;
      transition: color 0.3s;
      
      &:hover {
        color: $C2;
      }
      
      i {
        font-size: 16px;
      }
    }
    
    .header-title {
      flex: 1;
      text-align: center;
      font-family: HYXinRenWenSongW;
      font-size: 20px;
      font-weight: 600;
      color: $C13;
    }
  }
  
  .register-content {
    .register-layout {
      width: 800px;
      margin: 0 auto;
      
      .event-card {
        background: $C1;
        border: 1px solid $C11;
        margin-bottom: 30px;
        display: flex;
        
        .event-cover {
          width: 490px;
          height: auto;
          overflow: hidden;
          flex-shrink: 0;
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        
        .event-info {
          flex: 1;
          padding: 25px 30px;
          max-width: calc(100% - 490px);
          box-sizing: border-box;
          
          .event-title {
            font-family: HYXinRenWenSongW;
            font-size: 20px;
            font-weight: 600;
            color: $C13;
            margin-bottom: 15px;
            line-height: 1.4;
          }
          
          .event-meta {
            .meta-item {
              display: flex;
              align-items: center;
              gap: 10px;
              font-size: 14px;
              color: $C9;
              margin-bottom: 10px;
              
              .meta-icon {
                font-size: 16px;
                color: $C9;
              }
              
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
          
          .organizer-info {
            margin-top: 20px;
            
            .organizer-card {
              display: inline-flex;
              align-items: center;
              padding: 8px 14px;
              background: rgba(0, 0, 0, 0.03);
              border-radius: 16px;
              
              .organizer-logo {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                object-fit: cover;
                margin-right: 10px;
                flex-shrink: 0;
              }
              
              .organizer-detail {
                .organizer-name-row {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  
                  .organizer-name {
                    font-size: 14px;
                    color: $C13;
                    font-weight: 500;
                  }
                  
                  .certified-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 12px;
                    color: #ff6b35;
                    
                    i {
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      
      .ticket-section {
        background: $C1;
        border: 1px solid $C11;
        padding: 25px 30px;
        margin-bottom: 30px;
        
        .section-title {
          font-family: HYXinRenWenSongW;
          font-size: 18px;
          font-weight: 600;
          color: $C13;
          margin-bottom: 20px;
        }
        
        .ticket-card {
          padding: 20px;
          background: linear-gradient(135deg, #fff 0%, #fff5f5 100%);
          border: 1px solid #DA3F34;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          &.selected {
            box-shadow: 0 2px 8px rgba(218, 63, 52, 0.1);
          }
          
          .ticket-left {
            flex: 1;
            
            .ticket-name {
              font-size: 15px;
              color: $C13;
              margin-bottom: 8px;
            }
            
            .ticket-price {
              font-size: 24px;
              font-weight: 600;
              color: #DA3F34;
            }
          }
          
          .ticket-right {
            .selected-icon {
              font-size: 28px;
              color: #DA3F34;
            }
          }
        }
      }
      
      .form-section {
        background: $C1;
        border: 1px solid $C11;
        padding: 30px;
        margin-bottom: 30px;
        
        .section-title {
          font-family: HYXinRenWenSongW;
          font-size: 18px;
          font-weight: 600;
          color: $C13;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 1px solid $C11;
        }
        
        .form-content {
          .form-item {
            margin-bottom: 25px;
            
            &:last-child {
              margin-bottom: 0;
            }
            
            .form-label {
              display: block;
              font-size: 14px;
              color: $C9;
              margin-bottom: 10px;
              
              &.required::after {
                content: '*';
                color: #ee0a24;
                margin-left: 4px;
              }
            }
            
            .form-input,
            .form-textarea {
              width: 100%;
              padding: 12px 15px;
              font-size: 14px;
              color: $C13;
              background: #f7f8fa;
              border: 1px solid #e8e8e8;
              border-radius: 4px;
              transition: all 0.3s;
              box-sizing: border-box;
              
              &:focus {
                outline: none;
                background: #fff;
                border-color: #DA3F34;
              }
              
              &::placeholder {
                color: #bbb;
              }
            }
            
            .form-textarea {
              resize: vertical;
              min-height: 100px;
            }
          }
        }
        
        .form-tips {
          margin-top: 20px;
          padding: 15px;
          background: #f9f9f9;
          border-radius: 4px;
          font-size: 13px;
          color: $C9;
          line-height: 1.6;
        }
        
        .check-tips {
          margin-top: 20px;
          padding: 15px;
          background: rgba(255, 152, 0, 0.08);
          border-radius: 4px;
          display: flex;
          align-items: center;
          gap: 10px;
          
          .check-icon {
            font-size: 18px;
            color: #ff9800;
          }
          
          span {
            font-size: 13px;
            color: #ff9800;
            line-height: 1.5;
          }
        }
      }
      
      .bottom-action {
        padding: 20px 0;
        display: flex;
        justify-content: center;
        
        .submit-btn {
          width: 400px;
          height: 50px;
          background: linear-gradient(106.13deg, #DA3F34 3.9%, #DE6640 94.11%);
          border: none;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          cursor: pointer;
          transition: opacity 0.3s;
          
          &:hover:not(:disabled) {
            opacity: 0.9;
          }
          
          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
</style>
